import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import config from 'config';

import {
	setupCache,
	buildMemoryStorage,
	defaultKeyGenerator,
	defaultHeaderInterpreter,
} from 'axios-cache-interceptor';
import collect from '@wsc/utils/collect';

const instance = axios.create({
	baseURL: config.API_URL,
	crossDomain: true,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
});

const reportAPIMetric = (request, time) => {
	const url = new URL(request.config.url);
	const metricPayload = {
		name: 'api_request',
		value: time,
		method: request.config.method,
		path: url.pathname,
		host: url.host,
	};
	url.searchParams.forEach((value, key) => {
		metricPayload[`q__${key}`] = value;
	});
	if ('cf-cache-status' in request.headers) {
		metricPayload['cf-cache-status'] = request.headers['cf-cache-status'];
	} else {
		metricPayload['cf-cache-status'] = 'NONE';
	}
	collect(metricPayload);
};

const handleSuccess = (response) => {
	const reqTime = new Date().getTime() - response.config.meta.startedAt;

	if (reqTime > 0) {
		reportAPIMetric(response, reqTime);
	}
	return response;
};
const handleError = ({ error }) => Promise.reject(error);

instance.interceptors.request.use((req) => {
	req.meta = req?.meta || {};
	req.meta.startedAt = new Date().getTime();
	return req;
});

instance.interceptors.response.use(handleSuccess, handleError);

const cacheInstance = setupCache(instance, {
	baseURL: config.API_URL,
	storage: buildMemoryStorage(),
	generateKey: defaultKeyGenerator,
	headerInterpreter: defaultHeaderInterpreter,
});

export default cacheInstance;
